import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GlobalSidebar from '../GlobalSidebar/GlobalSidebar';
import GlobalTopbar from '../GlobalTopbar/GlobalTopbar';

import './GlobalAppWrapper.scss';

/** Describe the component */

const GlobalAppWrapper = props => {
  const {
    children,
    logo,
    sidebarLinks,
    topbarContentRight,
    topbarContentLeft,
  } = props;

  const [menuOpen, setMenuOpen] = useState(false);

  const toggle = () => {
    setMenuOpen(!menuOpen);
    document.activeElement.blur();
  };

  const openSidebar = () => {
    setMenuOpen(true);
  };

  const closeSidebar = () => {
    setMenuOpen(false);
  };

  // Set sidebar open state to false so we don't get the overlay etc
  useEffect(() => {
    const handleResize = () => window.innerWidth > 1200 && setMenuOpen(false);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <div
      className={classnames('global-app-wrapper', {
        'sidebar-open': menuOpen,
        'sidebar-closed': !menuOpen,
      })}
    >
      <GlobalTopbar
        contentRight={topbarContentRight}
        contentLeft={topbarContentLeft}
        toggleNav={toggle}
        hamburgerClassName={classnames({
          'menu-open': menuOpen,
        })}
        logo={logo}
      />
      <GlobalSidebar
        isOpen={menuOpen}
        links={sidebarLinks}
        openSidebar={openSidebar}
        closeSidebar={closeSidebar}
      />
      {children}
    </div>
  );
};

GlobalAppWrapper.propTypes = {
  /** Page contents */
  children: PropTypes.node,
  /** Logo image or element */
  logo: PropTypes.node,
  /** Links array containing all sidebar nav points */
  sidebarLinks: PropTypes.arrayOf(
    PropTypes.shape({
      current: PropTypes.bool,
      icon: PropTypes.node,
      link: PropTypes.string,
      title: PropTypes.node,
      type: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          current: PropTypes.bool,
          link: PropTypes.string,
          title: PropTypes.node,
        })
      ),
    })
  ),
  /** Space to put user, help dropdowns etc */
  topbarContentRight: PropTypes.node,
  topbarContentLeft: PropTypes.node,
};

GlobalAppWrapper.defaultProps = {
  children: null,
  logo: null,
  sidebarLinks: [],
  topbarContentRight: null,
  topbarContentLeft: null,
};

export default GlobalAppWrapper;
